import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { CONCAT_TEXT_LIMIT } from "../../../../functions/funtion";
import { dto_common } from "../../../../classes/dto-common";
import { Font } from "../../../../util/config-fonts";
import React from "react";

export default class HorizontalProductSecion extends React.PureComponent {
  render() {
    let data = this.props.data;
    if (data.IU === "" || data.IU === "N/A") {
      data.IU = dto_common.DefaultImageUrl;
    }
    return (
      <div
        style={{
          marginLeft: 10,
          marginTop: 10,
          marginBottom: 10,
          marginRight: 10,
          boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
          width: 115,
          height: 180,
          cursor: "pointer",
        }}
        onClick={() => {
          this.props.ItemClick(data);
        }}
      >
        <img
          src={data.IU}
          style={{ height: 100, width: 114 }}
          alt="image"
        />
        <p
          style={{
            margin: 0,
            lineClamp: 2,
            WebkitLineClamp: 2,
            padding: 5,
            paddingBottom: 0,
            textOverflow: "ellipsis",
            fontSize: Font.Description,
          }}
        >
          {CONCAT_TEXT_LIMIT({ length: 25, string: data.D.trim() })}
        </p>
        {data.UD > 0 ? (
          <>
            <p
              style={{
                margin: 0,
                lineClamp: 2,
                WebkitLineClamp: 2,
                paddingLeft: 5,
                paddingRight: 5,
                textAlign: "justify",
                fontSize: Font.Amount,
                textDecorationLine: "line-through",
                color: "red",
              }}
            >
              {dto_StartupPageLoadInfo.Currency +
                " " +
                data.P.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
            </p>
            <p
              style={{
                margin: 0,
                lineClamp: 2,
                WebkitLineClamp: 2,
                paddingLeft: 5,
                paddingRight: 5,

                fontSize: Font.Amount,
              }}
            >
              {dto_StartupPageLoadInfo.Currency +
                " " +
                (parseFloat(data.P) - parseFloat(data.UD))
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
            </p>
          </>
        ) : (
          <p
            style={{
              margin: 0,
              lineClamp: 2,
              WebkitLineClamp: 2,
              paddingLeft: 5,
              paddingRight: 5,
              fontSize: Font.Amount,
            }}
          >
            {dto_StartupPageLoadInfo.Currency +
              " " +
              data.P.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
          </p>
        )}
      </div>
    );
  }
}
